import { Badge } from "react-bootstrap";
import { BadgeProps } from "react-bootstrap";
import { Icon } from "../graphic/Icons";

export type IconWithBadgeProps = {
    iconName: string,
    size?: string | number | undefined,
    count: number | undefined,
    badgeProps? : BadgeProps
}

export default function IconWithBadge({ iconName, size = 24, count = 0, badgeProps = {pill: true, bg: "primary"} } : IconWithBadgeProps) {
    const {className, ...rest} = badgeProps;
    return (
    <div className="icon-wrapper">
      <Icon name={iconName} size={size} />
      {count > 0 && (
        <Badge {...rest} className={`badge-over-icon ${className || ''}`}>
          {count}
        </Badge>
      )}
    </div>
  );
}
